import React, { FC, useEffect, useState } from "react"
import LoadingOverlay from 'react-loading-overlay-ts';
import * as csv from "csvtojson";
import { Parser } from 'json2csv';

import { useAsync } from "../../../utils";
import { ISearchEsProduct, searchEsProduct } from "../../../api";
import { IDongGoi } from "../../../models";


enum requiredHeadersEnum {
    productName = "Tên sản phẩm"
}

enum productFields {
    name = "name",
    pageUrl = "pageUrl",
    _id = "_id",
    dong_goi = "dong_goi",
    category = "category"
}

enum outputHeadersEnum {
    medigoId = "Medigo - ID sản phẩm",
    name = "Medigo - Tên sản phẩm",
    pkgName = "Medigo - Loại đóng gói",
    stock = "Medigo - Tồn kho",
    suggestTopId = "Medigo - Top {replaceMe} ID",
    suggestTopName = "Medigo - Top {replaceMe} tên sp",
    suggestTopLink = "Medigo - Top {replaceMe} link",
    suggestTopPkgs = "Medigo - Top {replaceMe} đóng gói"
}

const requiredHeaders = Object.values(requiredHeadersEnum)

const AutoMapping: FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [loadingPercent, setLoadingPercent] = useState<number>(0)
    const [selectedFile, setSelectedFile] = useState<File | null>(null)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [searchSize, setSearchSize] = useState<number>(1)

    const [csvInfo, setCsvInfo] = useState<{
        headers: string[],
        rows: any[],
        errors: string[]
    }>({
        headers: [],
        rows: [],
        errors: []
    });
    const [outRows, setOutRows] = useState<any[]>([])

    const searchProductAsync = useAsync(searchEsProduct)

    useEffect(() => {
        let savedSize = localStorage.getItem("autoMappingSearchSize");
        if (savedSize) {
            setSearchSize(parseInt(savedSize))
        }
    }, [])

    const getQuery = ({ search, from, size }: ISearchEsProduct) => {
        return {
            from,
            size,
            _source: Object.values(productFields),
            query: {
                "bool": {
                    "must": {
                        "match": {
                            "name": {
                                "query": search,
                                "prefix_length": 2,
                                "fuzziness": "AUTO"
                            }
                        }
                    },
                    "should": {
                        "match": {
                            "Size_volume": {
                                "query": search
                            }
                        }
                    }
                }
            }
        }
    }

    const onFileChange = (files: FileList | null) => {
        if (!files
            || files.length === 0) {
            return;
        }
        let file = files[0];

        setSelectedFile(file);
        setIsSuccess(false);

        const reader = new FileReader();
        reader.onload = (e) => {
            if (e.target) {
                const text = e.target.result;
                if (text && typeof text === 'string') {
                    processCSV(text)
                }
            }
        }
        reader.readAsText(file);
    }

    const processCSV = async (str: string) => {
        const rows = await csv.default().fromString(str);
        let headers: string[] = [];

        if (rows
            && rows.length > 0) {
            for (let key in rows[0]) {
                headers.push(key)
            }
        }

        console.log(rows[0]);

        let errors = [];

        if (!isValidHeader(headers)) {
            errors.push(`Cần có đủ các cột: ${requiredHeaders.join(', ')}`);
        }

        if (!rows
            || rows.length === 0
        ) {
            errors.push(`Không tìm thấy dữ liệu, vui lòng kiểm tra lại`)
        }

        setCsvInfo({
            headers,
            rows,
            errors
        })
    }

    const isValidHeader = (headers: string[]) => {
        for (let col of requiredHeaders) {
            let temp = headers.includes(col);
            if (!temp) {
                return false;
            }
        }
        return true;
    }

    const handleSeach = async (value: string) => {
        const params = {
            from: 0,
            size: searchSize,
            search: value,
        }
        try {
            let res = await searchProductAsync.execute(getQuery(params))
            return res.data;
        } catch (err) {
            console.log("error: ", err);
        }
    }

    const onUploadClick = async () => {
        if (isLoading
            || csvInfo.errors.length > 0
            || !selectedFile
        ) {
            return;
        }

        setIsLoading(true)

        let totalItems = csvInfo.rows.length;

        console.log("total items: ", totalItems);

        let outRows: any[] = [];

        for (let i = 0; i < totalItems; ++i) {
            let row = csvInfo.rows[i];
            if (row[outputHeadersEnum.medigoId]) {
                outRows.push(Object.assign({}, row));
                continue;
            }

            let suggests = await handleSeach(row[requiredHeadersEnum.productName]);
            let validPkgs: IDongGoi[] = []

            if (suggests[0]) {
                let pkgs: IDongGoi[] = suggests[0][productFields.dong_goi];
                validPkgs = pkgs;
            } else {
                outRows.push(Object.assign({}, row));
                continue;
            }

            for (let pkg of validPkgs) {
                row[outputHeadersEnum.medigoId] = suggests[0][productFields._id]
                row[outputHeadersEnum.name] = suggests[0][productFields.name]
                row[outputHeadersEnum.pkgName] = pkg.loai_dong_goi.name;
                row[outputHeadersEnum.stock] = "Còn hàng"

                for (let k = 0; k < searchSize; ++k) {
                    if (suggests[k]) {
                        row[replaceString(outputHeadersEnum.suggestTopId, `${k + 1}`)] = suggests[k][productFields._id]
                        row[replaceString(outputHeadersEnum.suggestTopName, `${k + 1}`)] = suggests[k][productFields.name]
                        row[replaceString(outputHeadersEnum.suggestTopLink, `${k + 1}`)] = getProductUrl(suggests[k][productFields.category], suggests[k][productFields._id])
                        row[replaceString(outputHeadersEnum.suggestTopPkgs, `${k + 1}`)] = validPkgs.map(item => item.loai_dong_goi.name).join(",")
                    }
                }

                outRows.push(Object.assign({}, row));
            }

            setLoadingPercent(Math.floor((i + 1) * 100 / totalItems))
        }

        console.log("rows: ", outRows)
        setOutRows(outRows)

        setIsLoading(false)
        setIsSuccess(true)
    }

    const getProductUrl = (category: string, id: string) => {

        let productUrl = '';

        switch (category) {
            case 'c_tbyt':
                productUrl = process.env['REACT_APP_CMS_ROOT'] +
                    "/admin/plugins/content-manager/collectionType/application::p-tbyt.p-tbyt/" +
                    id;
                break;
            case 'c_med_otc':
            case 'c_med_rx':
                productUrl = process.env['REACT_APP_CMS_ROOT'] +
                    "/admin/plugins/content-manager/collectionType/application::product.product/" +
                    id;
                break;
            case 'c_tpcn':
                productUrl = process.env['REACT_APP_CMS_ROOT'] +
                    "/admin/plugins/content-manager/collectionType/application::p-tpcn.p-tpcn/" +
                    id;
                break;
            case 'c_mypham':
            case 'c_hangtieudung':
            case 'c_others':
                productUrl = process.env['REACT_APP_CMS_ROOT'] +
                    "/admin/plugins/content-manager/collectionType/application::p-other.p-other/" +
                    id;
                break;
            default:
                productUrl = process.env['REACT_APP_CMS_ROOT'] +
                    "/admin/";
                break;
        }

        return productUrl;

    }

    const replaceString = (str: string, value: string): string => {
        return str.replace("{replaceMe}", value);
    }

    const getDisableClass = () => {
        if (isLoading
            || !selectedFile
            || csvInfo.errors.length > 0) {
            return "disabled";
        }

        return "";
    }

    const FileErrors = () => {
        let maps = csvInfo.errors.map((error, index) => {
            return <div className="alert alert-danger" key={index}>
                <img alt="none" src="./images/report_problem.svg" title="Error" className="img-fluid" width="20" />
                <span className="ml-2">{error}</span>
            </div>
        })

        return <div>{maps}</div>
    }

    const handleChangeSuggestSize = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(e.target.value);
        let value = parseInt(e.target.value);
        if (isNaN(value)) {
            value = 0;
        }
        localStorage.setItem("autoMappingSearchSize", '' + value);
        setSearchSize(value)
    }

    const downloadFile = () => {
        if (!selectedFile
            || outRows.length == 0) {
            return;
        }

        let parser = new Parser()
        let csv = parser.parse(outRows)

        var blob = new Blob([csv], { "type": "text/csv;charset=utf8;" });

        var uri = 'data:attachment/csv;charset=utf-8,' + encodeURI(csv);
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute('visibility', 'hidden');
        link.download = selectedFile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }

    return (
        <div>
            <LoadingOverlay
                active={isLoading}
                spinner
                text={'Đang xử lý ... ' + loadingPercent + '%'}
                fadeSpeed={500}
            >
                {
                    isLoading ?
                        <div className="overlay-wrapper">
                        </div>
                        : ''
                }
            </LoadingOverlay>

            <div className="management-content">
                <div className="my-3 ">
                    Hướng dẫn thực hiện có thể xem <a href="https://medigo.atlassian.net/l/c/pYt5heAX" target="_blank">tại đây</a>
                </div>
                <div className="my-3">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon3">Số lượng kết quả gợi ý</span>
                        </div>
                        <input type="number" className="form-control" id="basic-url" aria-describedby="basic-addon3" value={searchSize} onChange={handleChangeSuggestSize} />
                    </div>
                </div>
                <div className="form-group form-file">
                    <input type="file" id="imgInp" name="img" accept=".csv" onChange={(e) => onFileChange(e.target.files)} />
                    <span className="input-label"><img alt="none" src="./images/MDI-upload.svg" title="Tải lên" className="img-fluid" width="24" /> <span>Tải File/Upload kho hàng</span></span>
                </div>
            </div>

            {
                selectedFile ?
                    <div>
                        <p>Tên file: <span>{selectedFile.name}</span></p>
                        <p>Số lượng sản phẩm: {new Intl.NumberFormat().format(csvInfo.rows.length)}</p>
                        <FileErrors />
                    </div>
                    : ''
            }

            {
                isSuccess ?
                    <div className="text-center mt-5 text-success">
                        Xử lý dữ liệu thành công
                        <button className="btn m-3 px-3" onClick={downloadFile}>Tải file</button>
                    </div> : ''
            }

            <div className="fixed-button">
                <a onClick={
                    (e) => {
                        e.preventDefault();
                        onUploadClick()
                    }
                } className={`btn btn-block ${getDisableClass()}`} href="/#">XỬ LÝ FILE</a>
            </div>

        </div>
    )
}

export default AutoMapping